import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class TombOfAkhenatenGameMode extends GameMode {
    static readonly RESPIN_FIRST: string = "RESPIN_FIRST";
    static readonly RESPIN_SECOND: string = "RESPIN_SECOND";
    static readonly RESPIN_FINAL: string = "RESPIN_FINAL";

    static readonly FS_RESPIN_FIRST: string = "FS_RESPIN_FIRST";
    static readonly FS_RESPIN_SECOND: string = "FS_RESPIN_SECOND";
    static readonly FS_RESPIN_FINAL: string = "FS_RESPIN_FINAL";
}